<template>
  <div>
    <div class="page_center">
      <div class="main">
        <div class="main-container">
          <div class="main_header">
            <div class="title-wrapper">
              <div class="sub_title">
                <span class="word_break fontLight"
                  >시니어 세대의 여가활동 증진 & 인지력 향상을 위한
                  <b>종합관리 플랫폼</b></span
                >
              </div>
              <div class="main_title">
                <span>HAPPY TABLE</span>
              </div>
            </div>
            <div class="sub-img web">
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_cooperation.png"
                  alt="협동"
                />
                <span class="block">협동</span>
              </p>
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_competition.png"
                  alt="경쟁"
                />
                <span class="block">경쟁</span>
              </p>
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_healing.png"
                  alt="힐링"
                />
                <span class="block">힐링</span>
              </p>
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_learning.png"
                  alt="학습"
                />
                <span class="block">학습</span>
              </p>
            </div>
            <div class="sub-img mobile">
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_cooperation.png"
                  alt="협동"
                />
                <span class="block orange">협동</span>
              </p>
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_competition.png"
                  alt="경쟁"
                />
                <span class="block orange">경쟁</span>
              </p>
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_healing.png"
                  alt="힐링"
                />
                <span class="block orange">힐링</span>
              </p>
              <p class="background-slide">
                <img
                  src="@/assets/source/images/main/ic_slide_learning.png"
                  alt="학습"
                />
                <span class="block orange">학습</span>
              </p>
            </div>
          </div>

          <div class="main-link-wrapper web-link">
            <div
              class="border-box"
              @mouseover="isBrandstoryImg = true"
              @mouseout="isBrandstoryImg = false"
            >
              <router-link to="/happytable" class="link">
                <img
                  v-show="!isBrandstoryImg"
                  src="@/assets/source/images/ic_brandstory.png"
                  alt="브랜드 이야기"
                />
                <img
                  v-show="isBrandstoryImg"
                  src="@/assets/source/images/ic_brandstory_hover.png"
                  alt="브랜드 이야기"
                />
                <span class="text" :class="{['link-text']: isBrandstoryImg}"
                  >브랜드 이야기</span
                >
              </router-link>
            </div>
            <div
              class="border-box"
              @mouseover="isProductImg = true"
              @mouseout="isProductImg = false"
            >
              <router-link to="/productinfo/32inch" class="link">
                <img
                  v-show="!isProductImg"
                  src="@/assets/source/images/ic_product.png"
                  alt="제품 소개"
                /><img
                  v-show="isProductImg"
                  src="@/assets/source/images/ic_product_hover.png"
                  alt="제품 소개"
                />

                <span class="text" :class="{['link-text']: isProductImg}"
                  >제품 소개</span
                >
              </router-link>
            </div>
            <div
              class="border-box"
              @mouseover="isInstallImg = true"
              @mouseout="isInstallImg = false"
            >
              <router-link to="/news/reference" class="link">
                <img
                  v-show="!isInstallImg"
                  src="@/assets/source/images/ic_installation.png"
                  alt="설치 사례"
                />
                <img
                  v-show="isInstallImg"
                  src="@/assets/source/images/ic_installation_hover.png"
                  alt="설치 사례"
                />

                <span class="text" :class="{['link-text']: isInstallImg}"
                  >설치 사례</span
                >
              </router-link>
            </div>
            <div
              @mouseover="isFaq = true"
              @mouseout="isFaq = false"
              class="border-box"
            >
              <router-link to="/news/faq" class="link">
                <img
                  v-show="!isFaq"
                  src="@/assets/source/images/ic_faq.png"
                  alt="FAQ"
                />
                <img
                  v-show="isFaq"
                  src="@/assets/source/images/ic_faq_hover.png"
                  alt="FAQ"
                />

                <span class="text" :class="{['link-text']: isFaq}">FAQ</span>
              </router-link>
            </div>
          </div>
        </div>

        <router-link class="text-deco-none" to="/happytable"> </router-link>
      </div>

      <div class="main-link-wrapper mobile">
        <div class="img-container">
          <router-link to="/happytable" class="link">
            <img
              src="@/assets/source/images/ic_brandstory.svg"
              alt="브랜드 이야기"
            />
            <span class="text">브랜드 이야기</span>
          </router-link>
        </div>
        <div class="img-container">
          <router-link to="/productinfo/32inch" class="link">
            <img src="@/assets/source/images/ic_product.svg" alt="제품 소개" />
            <span class="text">제품 소개</span>
          </router-link>
        </div>
        <div class="img-container">
          <router-link to="/news/reference" class="link">
            <img
              src="@/assets/source/images/ic_installation.svg"
              alt="설치 사례"
            />
            <span class="text">설치 사례</span>
          </router-link>
        </div>
        <div class="img-container">
          <router-link to="/news/faq" class="link">
            <img src="@/assets/source/images/ic_faq.svg" alt="FAQ" />
            <span class="text">FAQ</span>
          </router-link>
        </div>
      </div>
    </div>
    <notice-modal v-if="isOpenModal"></notice-modal>
    <notice-modal2 v-if="isOpenModal2"></notice-modal2>
  </div>
</template>

<script>
import NoticeModal from "@/components/modal/notice-modal.vue";
import NoticeModal2 from "./modal/notice-modal2.vue";
// import imageComponent from "./imageComponent.vue";
import Cookie from "@/utils/cookies.js";

export default {
  components: {NoticeModal, NoticeModal2},
  // components: {imageComponent},
  data() {
    return {
      isDesktop: true,
      isBrandstoryImg: false,
      isProductImg: false,
      isInstallImg: false,
      isFaq: false,
      name: "",
      footerHeight: "calc(100vh - 152px)",
      isOpenModal: false,
      isOpenModal2: false,
    };
  },

  created() {
    this.checkedCookie();
    this.checkedCookie2();
  },
  methods: {
    checkBrowserWidth() {
      this.isDesktop = window.innerWidth > 767;
    },

    changeImg(event) {
      this.name = event.target;
      this.isHoverImg = !this.isHoverImg;
    },

    checkedCookie() {
      if (Cookie.getCookie("notice") == "done") {
        this.isOpenModal = false;
      } else {
        this.isOpenModal = true;
      }
    },
    checkedCookie2() {
      if (Cookie.getCookie("event_notice") == "done") {
        this.isOpenModal2 = false;
      } else {
        this.isOpenModal2 = true;
      }
    },
    getFooterSize() {
      if (window.innerWidth > 1023 && window.innerWidth <= 1280) {
        var height = document.getElementById("FOOTER").clientHeight;
        height = height + "px";
        height = "calc(100vh - " + height + ")";
        this.footerHeight = height;
      } else {
        this.footerHeight = "calc(100vh - 152px)";
      }
    },
  },
  mounted() {
    this.getFooterSize();
    this.checkBrowserWidth();
    window.addEventListener("resize", this.checkBrowserWidth);
    window.addEventListener("resize", this.getFooterSize);
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  font-weight: 400;
}
.mobile {
  display: none;
}
.main {
  background: center left / cover no-repeat
    url("../assets/source/images/main/main_slide1.png");
  height: calc(100vh - 152px);
  /* animation: bg-change 10s infinite ease-in-out; */
  overflow: hidden;
}

/* @keyframes bg-change {
  0% {
    background: center center / cover no-repeat
      url("../assets/source/images/main_slide1.jpg");
  }
  25% {
    background-image: center center / cover no-repeat
      url("../assets/source/images/main_slide1.jpg");
  }
  50% {
    background: center center / cover no-repeat
      url("../assets/source/images/main_slide2.jpg");
  }
  75% {
    background-image: center center / cover no-repeat
      url("../assets/source/images/main_slide1.jpg");
  }
  100% {
    background: center center / cover no-repeat
      url("../assets/source/images/main_slide1.jpg");
  }
} */

.main-container {
  max-width: 1420px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  text-align: left;
  height: 100%;
  justify-content: space-around;
}
.main_header {
  max-width: 1420px;
  margin-top: 211px;
}
.main_title {
  font: normal normal 900 90px/113px TmonMonsori;
  letter-spacing: 3.6px;
  color: white;
  /* animation: text-shadow 10s infinite ease-in-out; */
  text-shadow: 2px 5px 10px #16700f52;
}
/* @keyframes text-shadow {
  0% {
    text-shadow: 2px 2px 8px #ff7f2a;
  }

  50% {
    text-shadow: 2px 2px 8px #519294;
  }

  100% {
    text-shadow: 2px 2px 8px #ff7f2a;
  }
} */

.sub_title {
  font-size: 1.5rem;
  letter-spacing: -0.7px;
  color: #416154;
  line-height: 2;
  /* animation: text-shadow 10s infinite ease-in-out; */

  /* text-shadow: 2px 2px 2px #ff7f2a; */
}

.sub-img {
  display: flex;
  padding-top: 3rem;
}
.background-slide {
  /* margin-right: 1rem; */
  width: 8.5rem;
  height: 8.5rem;
  background: center / contain no-repeat
    url("../assets/source/images/main/icon_circle.png");
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.background-slide img {
  width: 58px;
}

.background-slide span {
  color: #fff;
}
.main-link-wrapper {
  width: 100%;
  max-width: 1200px;
  display: flex;
  border-radius: 5rem;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background-color: #fff;
  padding: 27.5px 0;
}

.border-box {
  padding: 0 60px;
  border-right: 1px solid #e6e6e6;
}
.border-box:last-child {
  border: none;
}
.main-link-wrapper .link {
  align-items: center;
  display: flex;
  justify-content: center;
}

.main-link-wrapper .link img {
  padding: 1rem 1rem 1rem 0;
}

.main-link-wrapper .link img {
  padding: 1rem 1rem 1rem 0;
}

.main-link-wrapper .link:last-child {
  border-right: none;
}
.text {
  font-size: 1.1rem;
  color: #4c4948;
}
.link-text {
  color: #ff5230;
  font-weight: 600;
}

.main-link {
  display: flex;
  display: -ms-flexbox;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 60px;
  color: #2e2e2e;
  font-size: 18px;
}

.mobile {
  display: none;
}

/* @media (min-width: 320px) and (max-width: 1020px) {
  .main_title {
    font-size: 4rem;
    color: #ffff;
    padding: 4rem 0 1rem 2rem;

    text-shadow: 2px 2px 8px #ff7f2a;
  }
  /* .sub_title {
    font-size: 1rem;
    color: #fff;
    line-height: 2;
    padding-left: 2rem;
    text-shadow: 2px 2px 2px #ff7f2a;
  }
  .sub-img {
    padding-left: 2rem;

    width: 70%;
  }

  .background-slide {
    width: 6rem;
    height: 6rem;
  }

  .main-link-wrapper {
    height: 4rem;
    width: 90%;
  }
}*/

@media (max-width: 550px) {
  .background-slide {
    min-width: 5rem;
    min-height: 5rem;
    width: 23%;
    height: 23%;
  }
  .title-wrapper {
    line-height: 0.2;
  }
  .main {
    width: 100%;
  }
  .main_title {
    width: 100%;
    font-size: 2.5rem;
    /* /* padding: 4rem 1.5rem 0; */
    margin: 10px 0;
    color: #ffff;
    text-align: center;
    text-shadow: 2px 2px 8px #ff7f2a;
  }
  .sub_title {
    font-size: 0.9rem;
    color: #fff;
    text-align: center;

    line-height: 2;
    text-shadow: 2px 2px 2px #ff7f2a;
  }
  .sub-img {
    width: 100%;
  }
  .web-link {
    display: none;
  }
  .web {
    display: none;
  }

  .sub-img .web {
    display: none;
  }

  .sub-img mobile {
    justify-content: flex-end;
  }

  .mobile {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    /* height: 100%; */
    padding-bottom: 56px;

    justify-content: center;
  }
  .main-link-wrapper {
    height: 100%;
  }
  .main-catainer {
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
  }

  .main_header {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  /* .mobile .background-slide {
    width: 5.5rem;
    height: 5.5rem;
  } */
  .mobile .background-slide:last-child {
    margin-right: 0;
  }

  .menu_icon {
    right: 10px;
  }
  .link {
    flex-direction: column;
    background: #fff;
    width: 70%;
    height: 70%;
    padding: 26px 26px;
    justify-content: space-between;
    box-shadow: 0 0px 10px #00000029;
    border-radius: 20px;
    margin: 0 auto;
    /* margin-bottom: 20px; */
  }

  .img-container {
    width: 50%;
  }
  .link img {
    width: 50%;
  }

  span.text {
    font-size: 17px;
  }
  span.block {
    line-height: 1.3rem;
    font-size: 14px;
  }
}

@media (min-width: 551px) and (max-width: 767px) {
  .main-link-wrapper .link img {
    padding: 1rem;
  }
  .title-wrapper {
    line-height: 0.2;
  }
  .main {
    width: 100%;
  }
  .main_title {
    width: 100%;
    font-size: 3rem;
    /* /* padding: 4rem 1.5rem 0; */
    margin: 10px 0;
    color: #ffff;
    text-align: center;
    text-shadow: 2px 2px 8px #ff7f2a;
  }
  .sub_title {
    font-size: 1.1rem;
    color: #fff;
    text-align: center;

    line-height: 2;
    text-shadow: 2px 2px 2px #ff7f2a;
  }
  .sub-img mobile {
    justify-content: flex-end;
  }

  .sub-img {
    width: 100%;
  }

  .web-link {
    display: none;
  }
  .web {
    display: none;
  }

  .sub-img .web {
    display: none;
  }

  .mobile {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    /* height: 100%; */
    padding-bottom: 56px;

    justify-content: center;
  }

  .main-link-wrapper {
    height: 100%;
  }

  .main-catainer {
    justify-content: center;
    margin-bottom: 10px;
    width: 100%;
  }

  .main_header {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .mobile .background-slide {
    width: 7rem;
    height: 7rem;
    margin-right: 0.7rem;
  }
  .mobile .background-slide:last-child {
    margin-right: 0;
  }
  .link {
    flex-direction: column;
    background: #fff;
    width: 70%;
    height: 70%;
    padding: 26px 26px;
    justify-content: space-between;
    box-shadow: 0 0px 10px #00000029;
    border-radius: 10px;
  }

  .img-container {
    width: 25%;
  }
  .link img {
    width: 80%;
  }
  span.text {
    font-size: 14px;
  }

  span.block {
    line-height: 1.3rem;
    font-size: 14px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .sub-menu .last-menu {
    width: 200px;
  }
  .sub-menu {
    width: 100%;
    margin: 0 auto;
  }
  .main-catainer {
    justify-content: unset;
  }

  .main_title {
    font-size: 61px;
    padding-left: 3rem;
  }
  .sub_title {
    padding-left: 3rem;
    font-size: 1.2rem;
  }

  .sub-img.web {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .web .background-slide {
    /* background-color: #f83a15; */
  }

  .web {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    height: 100%;
    padding-bottom: 56px;
  }

  .main-link-wrapper.web-link {
    display: none;
  }
  .main-link-wrapper.mobile {
    height: 100%;
    display: flex;
    width: 100%;
  }
  /* .web .background-slide {
    width: 7rem;
    height: 7rem;
    margin-right: 0.7rem;
  }
  .web .background-slide:last-child {
    margin-right: 0;
  } */

  .link {
    flex-direction: column;
    background: #fff;
    width: 70%;
    height: 70%;
    padding: 26px 26px;
    justify-content: space-between;
    box-shadow: 0 0px 10px #00000029;
    border-radius: 10px;
  }

  /* .link {
    box-sizing: border-box;
    flex-direction: column;
    background: #fff;
    width: 165px;
    height: 165px;
    box-shadow: 0 0px 10px #00000029;
    border-radius: 20px;
  } */

  .main_header {
    font-size: 3rem;
  }

  .main {
    padding-top: 71px;
  }

  .link img {
    width: 50%;
    padding: 1rem;
  }
  span.block {
    line-height: 1.3rem;
    font-size: 14px;
  }
}

@media (max-width: 1023px) {
  .main-link-wrapper .img-container {
    box-sizing: border-box;
    width: 212.5px;
    height: 212.5px;
  }
  .main-link-wrapper .link img {
    padding: 1rem;
    width: 77.5px;
    height: 77.5px;
  }
  .main-link-wrapper .link .text {
    font-size: 17px;
  }
  .main {
    /* background: center center / cover no-repeat url("../assets/source/images/m_mainslide01.svg"); */
    background-position-x: 70%;
    background-position-y: bottom;
  }

  @keyframes bg-change {
    0% {
      background: center center / cover no-repeat
        url("../assets/source/images/m_mainslide01.svg");
    }

    50% {
      background: center center / cover no-repeat
        url("../assets/source/images/m_mainslide02.svg");
    }
    /* 25% {
    background-image: url("../assets/source/images/main_slide1.jpg");
  }



  75% {
    background-image: url("../assets/source/images/main_slide1.jpg");
  } */

    100% {
      background: center / cover no-repeat
        url("../assets/source/images/m_mainslide01.svg");
    }
  }

  .background-slide {
    /* background-color: #fff; */
  }
  div.sub-img.mobile .background-slide img {
    height: 30px;
    object-fit: contain;
  }
  div.sub-img.mobile .background-slide span {
    color: white;
  }

  .block.orange {
    color: #f83a15;
  }

  .main_header {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-catainer {
    justify-content: center;
    margin-bottom: 10px;
    width: 100%;
  }

  .sub-img .mobile {
    width: 90%;
  }
}
@media (min-width: 1281px) and (max-width: 1400px) {
  .sub-menu {
    width: 100%;
    margin: 0 auto;
  }

  .sub-menu.last-menu {
    width: 12.4rem;
  }
  .mobile {
    display: none;
  }
  .main_title {
    font-size: 4.5rem;
    color: #ffff;
    padding: 0 0 1rem 2rem;

    /* text-shadow: 2px 2px 8px #ff7f2a; */
  }
  .sub_title {
    font-size: 1.2rem;
    line-height: 2;
    padding-left: 2rem;
    /* text-shadow: 2px 2px 2px #ff7f2a; */
  }

  .sub-img {
    padding-left: 2.2rem;

    width: 100%;
  }
  .background-slide {
    width: 6.5rem;
    height: 6.5rem;
  }
  .background-slide img {
    width: 58px;
  }

  .main-link-wrapper {
    width: 95%;
    padding: 1.2rem 0;
  }
}
@media (min-width: 1024px) and (max-width: 1280px) {
  .menu-background .last-menu {
    width: 200px;
  }
  .main_title {
    font-size: 4rem;
    color: #ffff;
    padding: 0 0 1rem 2rem;
    width: 80%;
  }
  .sub_title {
    font-size: 1rem;
    padding-left: 2rem;
  }
  .sub-img {
    padding-left: 2rem;

    width: 70%;
  }

  .background-slide {
    width: 6rem;
    height: 6rem;
  }

  .main-link-wrapper {
    height: 4rem;
    width: 80%;
  }

  .mobile {
    display: none;
  }

  .web-link {
    width: 95%;
  }
  /* .main_title {
    font-size: 5rem;
    color: #ffff;
    padding: 1rem 0 0 2.2rem;
    text-shadow: 2px 2px 8px #ff7f2a;
  }

  .sub_title {
    font-size: 1.4rem;
    padding: 1rem 0 0 2.2rem;
  }
  .sub-img {
    padding-left: 2.2rem;

    width: 100%;
  }
  .background-slide {
    width: 7rem;
    height: 7rem;
  }
  .background-slide img {
    width: 58px;
  }

  .main-link-wrapper {
    width: 90%;
    padding: 0.8rem 0;
  } */
}
/* @media (min-width: 769px) and (max-width: 1023px) {
  .admin-login {
    display: none;
  }

  .main_header {
    height: 650px;
    padding-top: 150px;
  }
  .main_title {
    font-size: 50px;
  }
  .sub_title {
    font-size: 23px;
  }
} */
/*
@media (min-width: 500px) and (max-width: 767px) {
  .main_header {
    height: 680px;
    padding-top: 0px;
  }
  .main_title {
    font-size: 40px;
  }
  .sub_title {
    font-size: 20px;
  }
}
@media (min-width: 500px) and (max-width: 767px) {
  .main_header {
    height: 680px;
    padding-top: 0px;
  }
  .main_title {
    font-size: 40px;
  }
  .sub_title {
    font-size: 20px;
  }
} */
</style>
